import { render, staticRenderFns } from "./BOMProgress.vue?vue&type=template&id=2ae78a7c&scoped=true&"
import script from "./BOMProgress.vue?vue&type=script&lang=js&"
export * from "./BOMProgress.vue?vue&type=script&lang=js&"
import style0 from "./BOMProgress.vue?vue&type=style&index=0&id=2ae78a7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae78a7c",
  null
  
)

export default component.exports